import React, { useState } from "react";

const HLX_TOKEN = {
  address: "0x28d4e499c4cde621e1cea7c9cbf9d43bf75a9525", // HLX contract
  symbol: "HLX",
  decimals: 18,
  // Token logo URL (replace with actual HLX logo if available)
  image: "https://helix.org/assets/hlx.png",
};

// Ethereum mainnet
const ETHEREUM_CHAIN_ID = "0x1"; // 1 decimal
const ETHEREUM_PARAMS = {
  chainId: ETHEREUM_CHAIN_ID,
  chainName: "Ethereum",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: ["https://ethereum-rpc.publicnode.com"],
  blockExplorerUrls: ["https://etherscan.io"],
};

const AddHLXButton = ({ ensureEthereumNetwork = true }) => {
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);

  const switchToEthereumIfNeeded = async () => {
    try {
      await window.ethereum?.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: ETHEREUM_CHAIN_ID }],
      });
    } catch (err) {
      // If chain not added, add it
      if (err?.code === 4902) {
        await window.ethereum?.request({
          method: "wallet_addEthereumChain",
          params: [ETHEREUM_PARAMS],
        });
      } else {
        throw err;
      }
    }
  };

  const addHLX = async () => {
    if (!window.ethereum || !window.ethereum.isMetaMask) {
      setMsg("MetaMask not detected. Please install MetaMask.");
      return;
    }

    setBusy(true);
    setMsg(null);

    try {
      if (ensureEthereumNetwork) {
        await switchToEthereumIfNeeded();
      }

      const wasAdded = await window.ethereum.request({
        method: "wallet_watchAsset",
        params: {
          type: "ERC20",
          options: {
            address: HLX_TOKEN.address,
            symbol: HLX_TOKEN.symbol,
            decimals: HLX_TOKEN.decimals,
            image: HLX_TOKEN.image,
          },
        },
      });

      setMsg(wasAdded ? "HLX added to MetaMask 🎉" : "HLX was not added.");
      
      // Clear success message after 3 seconds
      if (wasAdded) {
        setTimeout(() => setMsg(null), 3000);
      }
    } catch (err) {
      setMsg(err?.message ?? "Something went wrong while adding HLX.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex flex-col gap-2">
      <button
        onClick={addHLX}
        disabled={busy}
        aria-label="Add HLX to MetaMask"
        className="inline-flex items-center justify-center gap-2 border-none rounded-[12px] h-[36px] px-4
                   bg-[#0f1115] text-white font-semibold text-[14px] w-fit
                   transition-all duration-200 ease-in-out
                   shadow-md hover:shadow-lg active:shadow-sm
                   transform hover:scale-105 active:scale-95
                   disabled:opacity-60 disabled:cursor-not-allowed"
      >
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/3/36/MetaMask_Fox.svg"
          alt="MetaMask"
          className="w-[18px] h-[18px]"
        />
        {busy ? "Adding…" : "Add HLX"}
      </button>
      
      {/* Status message */}
      {msg && (
        <p className="text-[12px] text-gray-600 font-medium text-center">
          {msg}
        </p>
      )}
    </div>
  );
};

export default AddHLXButton;

